import classes from "./PackageGreen.module.css";
function PackageGreen(props) {
  return (
    <div className={classes.cardContainer}>
      <div className={classes.greenline}></div>
      <div className={classes.info}>
        <h5>{props.package.Title}</h5>
        {/* <p className={classes.text}>{props.package.Packages}</p> */}
      </div>
      <div className={classes.childCard}>
        <div>خریداری شده</div>
      </div>
    </div>
  );
}
export default PackageGreen;
